<div class="container-fluid">
  <div class="card overflow-x-hidden">
    <div class="card-header nocollapse">
      Constant Sum Question
    </div>

    <div [hidden]="folderId == -1">
      <div class="bg-info p-1 mb-3">
        <div class="row">
          <div class="col-md-10">
            <span class="text-white pt-2" style="font-size:18px; display:inline-block"><b>Folder Name : </b>{{ folderName }}</span>
          </div>
          <div class="col-md-2 py-1">
            <button type="button" class="btn btn-primary btn-action" (click)="BackToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-arrow-left"></i> Back to Section</button>
            <button type="button" class="btn btn-primary btn-action mb-0" (click)="BackUrl()"><i class="fa fa-home"></i> Home</button>
          </div>
        </div>
      </div>
    </div>

    <div id="messageContainer" class="card-header nocollapse bg-info col-md-12 msg-container" style="display:none;">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <span id="message"></span>
    </div>

    <div class="card-body">
      <form [formGroup]="constantsumForm" class="col-md-12">
        <div class="nav-item dropdown p-2">
          <div class="card mb-3">
            <div class="card-header btn-primary" (click)="showSchemaPanel = !showSchemaPanel" style="cursor:pointer;">
              <b>  Question Title</b>
              <span class="float-end"><i class="fa" [ngClass]="{'fa-chevron-down': showSchemaPanel, 'fa-chevron-right': !showSchemaPanel}"></i></span>
            </div>
            <div class="collapse" [ngClass]="{'show': showTitlePanel}">
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-md-2">
                    <label data-required class="form-control-label" for="description">Title</label>
                  </div>
                  <div class="col-md-10">
                    <textarea class="form-control" style="width:100%" rows="10" id="description" name="description" formControlName="description" placeholder="Type Question" #description> </textarea>
                  </div>
                </div>
                <br />

                <div class="row mb-3">

                  <label class="form-control-label col-md-2" for="questionCategoryId"> Category</label>
                  <div class="col-md-3">
                    <select name="questionCategoryId" id="questionCategoryId" formControlName="questionCategoryId" class="form-control">
                      <option value="" selected>--Select--</option>
                      <option *ngFor="let item of questionCategoryList" [ngValue]="item?.questionCategoryId" [selected]="questionCategoryId==item?.questionCategoryId">
                        {{item.questionCategoryName}}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-auto">
                    <button type="button" class="btn btn-primary btn-action"
                            (click)="openCategoryModal()">
                      <i class="fa fa-plus"></i> Create Category
                    </button>
                  </div>
                  <label class="col-md-auto form-control-label" for="width"> Width</label>
                  <div class="col-md-2">
                    <input class="form-control" maxlength="1000" type="number" id="width" name="width" formControlName="width" placeholder="Width" />
                  </div>
                </div>

                <div class="row">
                  <label class="form-control-label col-md-2" for="shortName">Short Name</label>
                  <div class="col-md-3"><input class="form-control" maxlength="30" type="text" id="shortName" name="shortName" formControlName="shortName" placeholder="Short Name" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <button type="button" class="btn btn-primary btn-action" [disabled]="categoryList.length > 0"
                    (click)="openCreateUpdateCategoryModal()">
              <i class="fa fa-plus"></i> Add Categoryory
            </button>
          </div>
        </div>
        <br />
      </form>

      <!--<div class="collapse" [ngClass]="{'show': showSchemaPanel}">-->
      <div *ngFor="let item of categoryList">
        <span accordion-heading>
          <i class='fa fa-edit pr-2' style="cursor:pointer;" (click)="PatchCategoryModal(item.categoryId); openCreateUpdateCategoryModal()" title="Edit"></i>
          <!--<i class='fa fa-close pr-2' data-toggle="modal" data-target="#deleteModelConfirmation" (click)="DeleteCategory(item.categoryId)" title="Delete"></i>-->
          {{item.categoryName}} : {{item.categoryValue}}
        </span>

        <form [formGroup]="subCategoryForm" #f="ngForm">
          <div class="row">
            <div class="form-group col-md-10">
              <label data-required class="col-md-2 form-control-label" for="subCategoryName">Sub-Category</label>
              <input class="col-md-8 form-control-sm" type="text" id="subCategoryName" name="subCategoryName" formControlName="subCategoryName" placeholder="Sub-Category" />
              <input type="hidden" id="isResponsePresent" name="isResponsePresent" formControlName="isResponsePresent" />
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-primary btn-action" (click)="AddUpdateSubCategory(item.categoryId)"><i class="fa fa-map-o"></i> Add/Update Sub-Category</button>
            </div>
          </div>

          <div class="form-group">
            <isg-grid [rowData]="item?.categorySubCategoryList || []"
                      [columnDefs]="colDefsSubCategory"
                      [config]="{height: '320px'}"
                      (rowSelected)="onRowSelected($event)"
                      (gridReady)="onSubCategoryGridReady($event)">
            </isg-grid>
          </div>
        </form>
      </div>


    </div>

  </div>
  <div class="card-footer mt-5">
    <div class="col-md-12">
      <div class="text-center">
        <button type="submit" class="btn btn-primary btn-action" [disabled]="!constantsumForm.valid" (click)="saveConstantSumQuestion()"><i class="fa fa-save"></i> Save</button>
        <button type="submit" class="btn btn-secondary btn-action position-relative" (click)="BackUrl()" [hidden]="redirectedSectionId!=null || redirectedSurveyId!=null" style="z-index:9"><i class="fa fa-times"></i> Cancel</button>
        <button type="button" class="btn btn-secondary btn-action" (click)="BackToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-times"></i> Cancel</button>
      </div>
    </div>
  </div>
</div>
<!--========-->
<ng-template #CreateUpdateCategoryModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Create/Update Category</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="createCategoryForm" #f="ngForm">
      <div class="row align-items-center mb-2">
        <label data-required class="form-control-label col-md-4" for="categoryName">Category</label>
        <div class="col-md-8">
          <input class="form-control" type="text" id="categoryName" name="categoryName" formControlName="categoryName" placeholder="Category" />
        </div>
      </div>
      <div class="row align-items-center mb-2">
        <label data-required class="form-control-label col-md-4" for="categoryDescription">Description</label>
        <div class="col-md-8">
          <input class="form-control" type="text" id="categoryDescription" name="categoryDescription" formControlName="categoryDescription" placeholder="Description" />
        </div>
      </div>
      <div class="row align-items-center">
        <label data-required class="form-control-label col-md-4" for="categoryValue">Value</label>
        <div class="col-md-8">
          <input class="form-control" type="text" id="categoryValue" name="categoryValue" formControlName="categoryValue" placeholder="Value" />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    <button type="button" class="btn btn-primary btn-modal" [disabled]="!createCategoryForm.valid" (click)="AddUpdateCategory(categoryId); modal.close()"><i class="fa fa-save"></i> Save</button>
  </div>
</ng-template>
<ng-template #DeleteConfirmation let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    <button type="button" class="btn btn-danger btn-modal" (click)="DeleteSubCategory(); modal.close()"><i class="fa fa-trash"></i> Delete</button>
  </div>
</ng-template>

<ng-template #CreateCategoryModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Create Category</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="ResetQuesCategoryForm(); modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="quesCategoryForm" #f="ngForm">
      <div class="row align-items-center">
        <label data-required class="form-control-label col-md-4" for="quesCategoryName">Category</label>
        <div class="col-md-8">
          <input class="form-control" type="text" id="quesCategoryName" name="quesCategoryName" formControlName="quesCategoryName" placeholder="Category" />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="ResetQuesCategoryForm(); modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    <button type="button" class="btn btn-primary btn-modal" [disabled]="!quesCategoryForm.valid" (click)="AddQuesCategory(); modal.close()"><i class="fa fa-save"></i> Save</button>
  </div>
</ng-template>

